/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Priority_LowInputs */



/**
* | output |
* | --- |
* | "Low" |
*
* @param {Manual_Qc_Priority_LowInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_priority_low = /** @type {((inputs?: Manual_Qc_Priority_LowInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Priority_LowInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Faible")
	if (locale === "de") return /** @type {LocalizedString} */ ("Niedrig")
	if (locale === "it") return /** @type {LocalizedString} */ ("Basso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Низкий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Bajo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("低的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("低い")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Baixo")
	return /** @type {LocalizedString} */ ("Low")
});